module.exports = __webpack_public_path__ + "img/default-avatar.238c0f48.png";